import { Tabs } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import Commission from '../commission/Commission.jsx';
import IBWithdraw from '../wallet/withdraw/Withdraw.jsx';
import IBTeam from '../ibTeam/IBTeam.jsx';
import IBManager from '../iBManager/IBManager.jsx';
import { useResponsive } from '../../../hooks/useResponsive.js';

const REPORT_TABS = [
    { key: 'earning', label: 'Earning', component: Commission },
    { key: 'withdraw', label: 'Withdraw', component: IBWithdraw },
    { key: 'my_team', label: 'My Team', component: IBTeam },
    { key: 'my_sub_ib', label: 'My Sub IB', component: IBManager },
];

const IBReportsPage = () => {
    const { isMobile } = useResponsive();
    const { tab = 'earning' } = useParams();
    const navigate = useNavigate();

    const activeTab = REPORT_TABS.find((item) => item.key === tab) ?? REPORT_TABS[0];
    const ActiveComponent = activeTab.component;

    const handleTabChange = (key) => {
        navigate(`/ib/reports/${key}`);
    };

    return (
        <div>
            {isMobile && (
                <div className="mb-2 bg-white rounded-lg shadow-sm py-2 px-3">
                    <Tabs
                        activeKey={activeTab.key}
                        onChange={handleTabChange}
                        centered
                        size="large"
                        items={REPORT_TABS.map((item) => ({
                            key: item.key,
                            label: item.label,
                        }))}
                        className="custom-tabs mobile-account-tabs"
                    />
                </div>
            )}

            <ActiveComponent />
        </div>
    );
};

export default IBReportsPage;
